/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GiustificativiAllegatiRequestDTO
 */
export interface GiustificativiAllegatiRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof GiustificativiAllegatiRequestDTO
     */
    idLavoro?: number;
    /**
     * 
     * @type {number}
     * @memberof GiustificativiAllegatiRequestDTO
     */
    idTipoRimborso?: number;
}

/**
 * Check if a given object implements the GiustificativiAllegatiRequestDTO interface.
 */
export function instanceOfGiustificativiAllegatiRequestDTO(value: object): value is GiustificativiAllegatiRequestDTO {
    return true;
}

export function GiustificativiAllegatiRequestDTOFromJSON(json: any): GiustificativiAllegatiRequestDTO {
    return GiustificativiAllegatiRequestDTOFromJSONTyped(json, false);
}

export function GiustificativiAllegatiRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiustificativiAllegatiRequestDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idLavoro': json['idLavoro'] == null ? undefined : json['idLavoro'],
        'idTipoRimborso': json['idTipoRimborso'] == null ? undefined : json['idTipoRimborso'],
    };
}

export function GiustificativiAllegatiRequestDTOToJSON(json: any): GiustificativiAllegatiRequestDTO {
    return GiustificativiAllegatiRequestDTOToJSONTyped(json, false);
}

export function GiustificativiAllegatiRequestDTOToJSONTyped(value?: GiustificativiAllegatiRequestDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idLavoro': value['idLavoro'],
        'idTipoRimborso': value['idTipoRimborso'],
    };
}

